import React, { useEffect, useRef } from 'react';
import './App.css';
import 'ol/ol.css';  // Import OpenLayers styles
import { Map as OlMap } from 'ol';
import View from 'ol/View';
import TileLayer from 'ol/layer/Tile';
import OSM from 'ol/source/OSM';  // OpenStreetMap basemap

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>Welcome to GISBuild</h1>
        <p>

        </p>
        <p>
          Visit our website at <a href="https://gisbuild.com" target="_blank" rel="noopener noreferrer">gisbuild.com</a> to explore more!
        </p>
      </header>
      {/* Add margin to separate map from text */}
      <div style={{ width: '100%', height: '500px', marginTop: '30px' }}>
        <Map />
      </div>
    </div>
  );
}

function Map() {
  const mapRef = useRef(null);

  useEffect(() => {
    // Initialize the OpenLayers map
    const map = new OlMap({
      target: mapRef.current,  // The map will be attached to this div
      layers: [
        new TileLayer({
          source: new OSM(),  // OpenStreetMap as the basemap
        }),
      ],
      view: new View({
        center: [-119.4179, 36.7783], // Longitude, Latitude for California
        zoom: 6, // Adjust zoom level to fit California
        projection: 'EPSG:4326',  // Use the geographic coordinate system (WGS84)
      }),
    });

    return () => {
      // Clean up map when component unmounts
      if (map) {
        map.setTarget(null);
      }
    };
  }, []);

  return <div style={{ height: '100%', width: '100%' }} ref={mapRef}></div>;
}

export default App;
